import {
    WHATSAPP_CHANNEL,
    OUTCOME_DIRECTION,
} from 'src/constants/conversations';

export const TEMPLATE_CATEGORY_GREETING = 'greeting';
export const TEMPLATE_CATEGORY_GRATITUDE = 'gratitude';
export const TEMPLATE_CATEGORY_FOLLOW_UP = 'follow-up';
export const TEMPLATE_CATEGORY_PROMOTION = 'promotion';
export const TEMPLATE_CATEGORY_DOCUMENTATION = 'documentation';
export const TEMPLATE_CATEGORY_APPOINTMENT = 'appointment';
export const TEMPLATE_CATEGORY_WELCOME = 'welcome';
export const TEMPLATE_CATEGORY_CLOSING = 'closing';
export const TEMPLATE_CATEGORY_LOCATION = 'location';
export const TEMPLATE_CATEGORY_BDC = 'bdc';
export const TEMPLATE_CATEGORY_ALL = 'all';

export const TEMPLATE_CATEGORY_SCHEDULE_APPOINTMENT_PROTOCOL =
    'scheduleAppointmentProtocol';
export const TEMPLATE_CATEGORY_NO_CONTACTED_PROTOCOL = 'noContactedProtocol';
export const TEMPLATE_CATEGORY_UNSOLD_PROTOCOL = 'unsoldProtocol';
export const TEMPLATE_CATEGORY_NO_ANSWER_5_DAYS_PROTOCOL =
    'noAnswer5DaysProtocol';
export const TEMPLATE_CATEGORY_PURCHASE_FOLLOW_UP_PROTOCOL =
    'purchaseFollowUpProtocol';
export const TEMPLATE_CATEGORY_CONTACTED_WITHOUT_RESPONSE_PROTOCOL =
    'contactedWithoutResponseProtocol';
export const TEMPLATE_CATEGORY_REACTIVATION_PROTOCOL = 'reactivationProtocol';

export const TEMPLATE_CATEGORY_BDC_SUBCATEGORIES = [
    TEMPLATE_CATEGORY_SCHEDULE_APPOINTMENT_PROTOCOL,
    TEMPLATE_CATEGORY_NO_CONTACTED_PROTOCOL,
    TEMPLATE_CATEGORY_UNSOLD_PROTOCOL,
    TEMPLATE_CATEGORY_PURCHASE_FOLLOW_UP_PROTOCOL,
    TEMPLATE_CATEGORY_CONTACTED_WITHOUT_RESPONSE_PROTOCOL,
    TEMPLATE_CATEGORY_REACTIVATION_PROTOCOL,
];

export const TEMPLATE_CATEGORIES = [
    TEMPLATE_CATEGORY_GREETING,
    TEMPLATE_CATEGORY_GRATITUDE,
    TEMPLATE_CATEGORY_FOLLOW_UP,
    TEMPLATE_CATEGORY_PROMOTION,
    TEMPLATE_CATEGORY_DOCUMENTATION,
    TEMPLATE_CATEGORY_APPOINTMENT,
    TEMPLATE_CATEGORY_WELCOME,
    TEMPLATE_CATEGORY_CLOSING,
    TEMPLATE_CATEGORY_LOCATION,
    TEMPLATE_CATEGORY_BDC,
];

export interface ITemplateCategory {
    id: string;
    label: string;
    icon: React.ReactElement | null;
    subcategories?: ITemplateCategory[];
}

export const TEMPLATE_CATEGORIES_WITH_ICONS: ITemplateCategory[] = [
    {
        id: TEMPLATE_CATEGORY_ALL,
        label: TEMPLATE_CATEGORY_ALL,
        icon: null,
    },
    {
        id: TEMPLATE_CATEGORY_GREETING,
        label: TEMPLATE_CATEGORY_GREETING,
        icon: null,
    },
    {
        id: TEMPLATE_CATEGORY_WELCOME,
        label: TEMPLATE_CATEGORY_WELCOME,
        icon: null,
    },
    {
        id: TEMPLATE_CATEGORY_APPOINTMENT,
        label: TEMPLATE_CATEGORY_APPOINTMENT,
        icon: null,
    },
    {
        id: TEMPLATE_CATEGORY_FOLLOW_UP,
        label: TEMPLATE_CATEGORY_FOLLOW_UP,
        icon: null,
    },
    {
        id: TEMPLATE_CATEGORY_GRATITUDE,
        label: TEMPLATE_CATEGORY_GRATITUDE,
        icon: null,
    },
    {
        id: TEMPLATE_CATEGORY_PROMOTION,
        label: TEMPLATE_CATEGORY_PROMOTION,
        icon: null,
    },
    {
        id: TEMPLATE_CATEGORY_DOCUMENTATION,
        label: TEMPLATE_CATEGORY_DOCUMENTATION,
        icon: null,
    },
    {
        id: TEMPLATE_CATEGORY_LOCATION,
        label: TEMPLATE_CATEGORY_LOCATION,
        icon: null,
    },
    {
        id: TEMPLATE_CATEGORY_CLOSING,
        label: TEMPLATE_CATEGORY_CLOSING,
        icon: null,
    },
    {
        id: TEMPLATE_CATEGORY_BDC,
        label: 'BDC',
        icon: null,
        subcategories: [
            {
                id: TEMPLATE_CATEGORY_SCHEDULE_APPOINTMENT_PROTOCOL,
                label: TEMPLATE_CATEGORY_SCHEDULE_APPOINTMENT_PROTOCOL,
                icon: null,
            },
            {
                id: TEMPLATE_CATEGORY_NO_CONTACTED_PROTOCOL,
                label: TEMPLATE_CATEGORY_NO_CONTACTED_PROTOCOL,
                icon: null,
            },
            {
                id: TEMPLATE_CATEGORY_UNSOLD_PROTOCOL,
                label: TEMPLATE_CATEGORY_UNSOLD_PROTOCOL,
                icon: null,
            },
            {
                id: TEMPLATE_CATEGORY_PURCHASE_FOLLOW_UP_PROTOCOL,
                label: TEMPLATE_CATEGORY_PURCHASE_FOLLOW_UP_PROTOCOL,
                icon: null,
            },
            {
                id: TEMPLATE_CATEGORY_CONTACTED_WITHOUT_RESPONSE_PROTOCOL,
                label: TEMPLATE_CATEGORY_CONTACTED_WITHOUT_RESPONSE_PROTOCOL,
                icon: null,
            },
            {
                id: TEMPLATE_CATEGORY_NO_ANSWER_5_DAYS_PROTOCOL,
                label: TEMPLATE_CATEGORY_NO_ANSWER_5_DAYS_PROTOCOL,
                icon: null,
            },
            {
                id: TEMPLATE_CATEGORY_REACTIVATION_PROTOCOL,
                label: TEMPLATE_CATEGORY_REACTIVATION_PROTOCOL,
                icon: null,
            },
        ],
    },
];

export const TEMPLATE_SELECT_QUERY =
    '_id title message templateTitle contentTemplateBuilder templateType category language';

export const TEMPLATE_CONTEXTS_TYPES = {
    LEAD: 'lead',
    CONVERSATION: 'conversation',
    SERVICE_CLIENT: 'serviceClient',
    AUTO: 'auto',
};

export const DEFAULT_CONVERSATION_CONFIG = {
    channel: WHATSAPP_CHANNEL,
    direction: OUTCOME_DIRECTION,
    from: '',
    isContentTemplateBuilder: true,
};
